<template>
  <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="10" fill="currentColor" />
    <path d="M10 14h6v-4H10v4zm2-2h2v2h-2v-2z" fill="var(--color-bg, #faf9f7)" />
    <path d="M24 10v4h6v-4h-6zm4 2h-2v2h2v-2z" fill="var(--color-bg, #faf9f7)" />
    <path d="M10 26v4h6v-4h-6zm4 2h-2v2h2v-2z" fill="var(--color-bg, #faf9f7)" />
    <path d="M20 12h2v2h-2v-2zm4 0h2v2h-2v-2zm-2 4h4v2h-4v-2zm-6 4h2v4h-2v-4zm10-2h2v2h-2v-2zm-4 2h4v2h-4v-2zm2 4h2v4h-2v-4zm-8 2h2v2h-2v-2zm14-4h2v6h-2v-6z" fill="var(--color-bg, #faf9f7)" />
  </svg>
</template>
